const prefixToParentMap = {
  'radio-vega-': 'yle-radio-vega',
  'yle-radio-suomi-': 'yle-radio-suomi',
} as const;

export function getParentChannel(channelId: string): string | null {
  for (const [prefix, parentId] of Object.entries(prefixToParentMap)) {
    if (channelId.startsWith(prefix)) return parentId;
  }
  return null;
}
